<template>
  <div>
    <b-card>
       <b-row class="create_team">
        <b-col cols="8" class="text-left">
          <h4>Auth Configuration</h4>
        </b-col>
        <b-col cols="4" class="text-right">
          <b-button type="submit" size="sm" variant="secondary" class="mt-0" @click="$refs.generateKeys.show()">
            <i class="fa fa-plus"> </i> <span> GENERATE KEYS </span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
<b-row>
    <b-col cols="12" v-for="token in accountTokens" :key="token.id">
      <b-card>
        <b-card border-variant="info" align="left">
          <div slot="header">
            <b-row>
              <b-col md="8">
                <h5>{{ token.name }}</h5>
              </b-col>
              <b-col md="4">
                <div class="float-right add-field-btn">
                  <b-button type="submit" size="sm" variant="danger" class="mt-0" @click="showDeleteModal(token.id)"><i class="fa fa-trash"></i></b-button>
                </div>
              </b-col>
            </b-row>
          </div>
          <p class="card-text">
            <b-row >
              <b-col cols="4">Client ID:</b-col>
              <b-col cols="8 text-left">{{token.client_id}}</b-col>
            </b-row>
            <b-row >
              <b-col cols="4">Client secret:</b-col>
              <b-col cols="8 text-left">{{token.client_secret}}</b-col>
            </b-row>
          </p>
        </b-card>
      </b-card>
    </b-col>
  </b-row>
     <b-modal centered hide-header-close id = "addKeys" ref="generateKeys" :title="$t('CONFIGURED.ADD_NEW_KEYS')">
      <b-card class="mb-0 p-3">
        <b-row class="form-group">
          <b-col cols="12">
            <b-form-group :label="$t('COMMON.NAME')" label-for="roleName">
              <b-form-input
                type="text" placeholder="Key Name"
                :class="{'is-invalid': $v.name.$error, 'is-valid': !$v.name.$invalid}" 
                v-model="name"
                @input="$v.name.$touch()">
              </b-form-input>
              <b-form-invalid-feedback v-if="!$v.name.required">Key Name can't be blank</b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="!$v.name.minLength || !$v.name.maxLength">Key Name length should be more than 3 and less than 15 characters</b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="!$v.name.valid">Key Name can't accept symbols</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <div slot="modal-footer">
        <b-btn id ="addNewField" size="sm" variant="secondary" @click="createKeys()" :disabled = " name === '' || !nameIsValid">{{ $t('COMMON.SAVE') }} </b-btn>
        <b-btn size="sm" variant="light" @click="$refs.generateKeys.hide()"> {{ $t('COMMON.CLOSE') }} </b-btn>
      </div>
    </b-modal>
    <b-modal centered
    id="deleteModal"
    ref="deleteModal"
    :title="$t('COMMON.DELETE_CONFIRM')"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    :ok-title="$t('COMMON.DELETE')"
    :cancel-title="$t('COMMON.CANCEL')"
    ok-variant="secondary"
    cancel-variant="light"
    @cancel="cancel"
    @keydown.native.enter="deleteAccountToken"
    @ok="deleteAccountToken" >
    <div class="delete-warning">
      <p>{{$t('COMMON.DEL_AUTHCONFIG')}}</p>
    </div>
    </b-modal>
  </div>  
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      name: '',
      accountTokens: [],
      token_id: null
    }
  },
  mounted () {
    this.fetchTeams()
  },
  computed: {
    ...mapGetters(['idToken']),
    nameIsValid () {
      return !this.$v.name.$error
    }
  },
  validations: {
    name: {
      required,
      maxLength: maxLength(15),
      minLength: minLength(3),
      valid: function (value) {
        const regexExp = /^[a-zA-Z0-9 _-]*$/.test(value)
        return regexExp
      }
    }
  },
  methods: {
    showDeleteModal (tokenId) {
      this.token_id = tokenId
      this.$refs['deleteModal'].show()
    },
    cancel () {
      this.$refs['deleteModal'].hide()
    },
    fetchTeams () {
      Vue.axios.get('settings/account_tokens', { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.accountTokens = res.data.tokens
        })
        .catch(error => {
          if (error.status === 401) {
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    createKeys () {
      Vue.axios.post('settings/account_tokens', {name: this.name}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.status) {
            this.accountTokens.push(res.data.account_token)
            this.$refs.generateKeys.hide()
          } else {
            Vue.toasted.show(res.data.message, { type: 'error' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    deleteAccountToken () {
      Vue.axios.delete('/settings/account_tokens/' + this.token_id, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          if (response.data.deleted) {
            this.accountTokens = this.accountTokens.filter((token, index) => { return token.id !== this.token_id })
            Vue.toasted.show(this.$t('COMMON.MSG_DELETE'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_DELETE_ERR'), { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.delete-warning {
  font-size : 1rem;
  color: red;
}
.card {
  background: #ebeff3;
  border-radius: 10px;

  .bar {
    width: 100%;
    height: 10px;
    border-radius: 10px 10px 0 0;
  }

  .card-header {
    border-radius: 10px 10px 0 0;
    background-color: #e7e7e7;
    padding: 1rem;
  }
}

.top-layer {
  justify-content: space-between;
  padding: 0 1.25em;
}

.modal-button {
  border-radius: 0px;
  margin-left: 5px;
  margin-right: 5px;
  padding-left: 3rem;
  padding-right: 3rem;
  float: right !important;
}

.required {
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/settings/authConfig.vue